import { httpCreate } from './http';
const http = httpCreate('/srv/capacity');
export const capacity = {
	/** 添加直播间扩容配置
	 *
	 * @param { Number } data.activityId 直播间Id
	 * @param { Number } data.expansionCapacity 扩容容量
	 * @param { Number } data.startTime 开始时间 时间戳
	 * @param { Number } data.endTime 结束时间 时间戳
	 * @returns
	 */
	addCapacityWork(data) {
		return http.post('/capacityConfig', data);
	},
	// 删除直播间扩容任务
	deleteCapacityWork(workId) {
		return http.delete(`/capacityConfig/${workId}`);
	},
	// 修改直播间扩容任务 data同添加
	updateCapacityWork(workId, data) {
		return http.put(`/capacityConfig/${workId}`, data);
	},
	/** 获取列表
	 *
	 * @param { String } params.keyword 直播ID或者名称
	 * @param { Number } params.pageNum 页码
	 * @param { Number } params.pageSize 页容量
	 * @returns
	 */
	getWorkList(params) {
		return http.get('/getCapacityPageList', { params });
	},
	// 开启直播间容量配置
	openCapacityWork(workId) {
		return http.put(`/open/${workId}`);
	},
	// 关闭直播间容量配置
	closeCapacityWork(workId) {
		return http.put(`/close/${workId}`);
	},
	// 获取直播标题
	getActivityTitleList(keyWord) {
		return http.get(`/activityCapacity/search/${keyWord}`);
	},

	/** 获取同时开播列表
	 *
	 * @param { String } params.keyword 直播ID或者名称
	 * @param { Number } params.pageNum 页码
	 * @param { Number } params.pageSize 页容量
	 * @returns
	 */
	getLiveNumWorkList(params) {
		return http.get('/getLiveNumPageList', { params });
	},
	/** 添加同时开播配置
	 *
	 * @param { Number } data.mobPhone 直播间Id
	 * @param { Number } data.videoLiveNum 同时开播数量
	 * @param { Number } data.startTime 开始时间 时间戳
	 * @param { Number } data.endTime 结束时间 时间戳
	 * @returns
	 */
	addLiveNumWork(data) {
		return http.post('/liveNumConfig', data);
	},
	// 修改同时开播任务 data同添加
	updateLiveNumWork(workId, data) {
		return http.put(`/liveNumConfig/${workId}`, data);
	},
	// 删除同时开播任务
	deleteLiveNumWork(workId) {
		return http.delete(`/liveNumConfig/${workId}`);
	},
	// 获取用户名
	getUserNickname(keyWord) {
		return http.get(`/activityLiveNum/search/${keyWord}`);
	},
	// 开启同时开播配置
	openLiveNumWork(workId) {
		return http.put(`/open/${workId}`);
	},
	// 关闭同时开播配置
	closeLiveNumWork(workId) {
		return http.put(`/close/${workId}`);
	},
	// 获取直播间扩容数据
	getActivityVolumeInfo(activityId) {
		return http.get(`/activityConfig/${activityId}`);
	},
	// 获取用户流量配置列表
	getFluxOverList(params) {
		return http.get('/fluxOverList', { params });
	},
	// 新增用户流量超出配置
	addFluxOver(data) {
		return http.post('/fluxOver', data);
	},
	// 删除用户流量超出配置
	deleteFluxOver(workId) {
		return http.delete(`/fluxOver/${workId}`);
	},
};
